import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ConsolidatedDto } from '@interfaces/partner-income-tax/responses/partner-income-tax.response';
import {
  formatCompactMoney,
  formatPersonName,
} from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/utils/partner-income-tax-format.util';

/**
 * "Garantias por sócio" (aba interna do consolidado, só com política): uma barra por sócio com a capacidade livre sem
 * restrição e com restrição, proporcional à capacidade livre somada, com a legenda. Sem a razão contra uma "garantia
 * exigida" desde a revisão de 29/10/2026 (a exigência depende da operação, não do IR). Aqui só se desenha.
 */
@Component({
  selector: 'app-pit-coverage-card',
  standalone: true,
  templateUrl: './coverage-card.component.html',
  styleUrl: './coverage-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageCardComponent {
  readonly consolidated = input.required<ConsolidatedDto>();

  protected readonly money = formatCompactMoney;

  /** Barras por sócio: largura proporcional à capacidade livre somada (barra cheia). */
  protected readonly bars = computed(() => {
    const c = this.consolidated();
    const base = c.freeCollateralTotal ?? 0;
    const pct = (value: number | null) =>
      base > 0 && value ? Math.min(100, (value / base) * 100) : 0;
    return c.partnersCoverage.map(item => ({
      ...item,
      displayName: formatPersonName(item.name),
      unrestrictedWidth: pct(item.unrestricted),
      restrictedWidth: pct(item.restricted),
      label: [
        item.unrestricted != null ? `${formatCompactMoney(item.unrestricted)} sem restrição` : null,
        item.restricted ? `${formatCompactMoney(item.restricted)} restrito` : null,
      ]
        .filter(Boolean)
        .join(' · '),
    }));
  });
}
